<script setup lang="ts">
	const props = defineProps<{
		errors: Record<string, any[]>
	}>()

	const emits = defineEmits<{
		(e: 'remove-traveler', travelerId: number): void
		(e: 'clear-error', key: string, index: number): void
		(e: 'close-alert', travelersIds: number[]): void
	}>()

	function removeTraveler(key: string, index: number, travelerId: number) {
		emits('remove-traveler', travelerId)
		emits('clear-error', key, index)
	}
</script>

<template>
	<div
		v-if="Object.keys(errors).length"
		class="fixed right-4 top-4 max-w-sm w-full z-50 transform transition-all duration-300 ease-in-out"
	>
		<div
			class="bg-white border border-teal-300 rounded-lg shadow-lg overflow-hidden"
		>
			<div class="bg-gradient-to-r from-teal-400 to-green-600 px-4 py-3">
				<div class="flex items-center gap-2">
					<div
						class="w-6 h-6 bg-white bg-opacity-20 rounded-full flex items-center justify-center"
					>
						<span class="material-symbols-outlined text-white text-sm"
							>warning</span
						>
					</div>
					<h3 class="text-white font-bold text-sm">Conflictos de Reserva</h3>

					<button
						@click="
							emits(
								'close-alert',
								Object.values(errors).flatMap((msgs) =>
									msgs.map((m) => m.travelerId)
								)
							)
						"
						class="ml-auto text-white hover:text-gray-200 transition-colors duration-200"
						title="Cerrar alerta"
					>
						✕
					</button>
				</div>
			</div>

			<div class="p-4 space-y-3 max-h-80 overflow-y-auto">
				<div
					v-for="(messages, key) in errors"
					:key="key"
					class="space-y-2"
				>
					<template v-if="key === 'users'">
						<div class="bg-amber-50 border-l-4 border-amber-400 p-3 rounded-r">
							<p class="text-amber-800 text-xs font-medium leading-relaxed">
								{{ messages[0] }}
							</p>
						</div>
					</template>

					<template v-else>
						<div
							v-for="(msg, i) in messages"
							:key="i"
							class="bg-red-50 border border-red-200 rounded-lg p-3 group hover:bg-red-100 transition-colors duration-200"
						>
							<div class="flex items-start justify-between gap-3">
								<div class="flex-1 min-w-0">
									<p class="text-red-800 text-xs font-medium mb-1">
										{{ msg.message }}
									</p>
								</div>

								<button
									@click="removeTraveler(key, i, msg.travelerId)"
									class="flex-shrink-0 w-6 h-6 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center transition-colors duration-200 opacity-70 group-hover:opacity-100"
									title="Eliminar viajero"
								>
									<span class="material-symbols-outlined text-xs">close</span>
								</button>
							</div>
						</div>
					</template>
				</div>
			</div>

			<div
				class="bg-gradient-to-r from-gray-50 to-gray-100 px-4 py-2 border-t border-gray-200"
			>
				<p class="text-xs text-gray-500 text-center">
					{{ Object.keys(errors).filter((k) => k !== 'users').length }}
					conflicto(s) encontrado(s)
				</p>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.material-symbols-outlined {
		font-variation-settings:
			'FILL' 1,
			'wght' 400,
			'GRAD' 0,
			'opsz' 24;
	}
</style>
